<template>
    <transition name="cz3__fade">
        <div
            v-if="showModal"
            class="z-50 fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-black bg-opacity-30"
        >
            <div class="shadow-md rounded w-full md:w-11/12 max-w-5xl h-full p-4 md:p-9 flex flex-col bg-white text-ink">
                <div class="mb-4 flex justify-end">
                    <button
                        @click="emitClose"
                        type="button"
                        aria-label="close modal"
                    >
                        <img
                            src="../assets/images/icons/close.svg"
                            width="20"
                            height="20"
                            alt="X"
                        >
                    </button>
                </div>

                <div class="flex-1 overflow-auto">
                    <div
                        class="cz3-size-guide-modal"
                    >
                        <div v-if="useRealContent" class="size-inner" v-html="sizeGuideHtml">
                        </div>

                        <div v-else class="size-inner">
                            <h2 class="size-tlt">Size Guide</h2>
                            <h3 class="size-find-tlt">Find Your Size</h3>
                            <hr>
                            <div class="size-conversion">
                                <span class="size-label">Men's Shoes Size Conversion Chart</span>
                                <div class="btn-toggle rule-in">
                                    <div class="btn-in">in.</div>
                                    <div class="btn-cm">cm.</div>
                                </div>
                            </div>
                            <div class="size-scroll relative">
                                <!-- eslint-disable max-len -->
                                <table class="size-shoes size-grey-theme">
                                    <tbody>
                                        <tr>
                                            <td class="fit-column-1 hdr-cell hdr-column hdr-fixed hdr-fixed-corner">Foot Length <span class="chart-in">(in.)</span><span class="chart-cm">(cm.)</span></td>
                                            <td class="fit-column-2 hdr-cell hdr-column"><span class="chart-in">9.45</span><span class="chart-cm">24.0</span></td>
                                            <td class="fit-column-3 hdr-cell hdr-column"><span class="chart-in">9.65</span><span class="chart-cm">24.5</span></td>
                                            <td class="fit-column-4 hdr-cell hdr-column"><span class="chart-in">9.84</span><span class="chart-cm">25.0</span></td>
                                            <td class="fit-column-5 hdr-cell hdr-column"><span class="chart-in">10.0</span><span class="chart-cm">25.5</span></td>
                                            <td class="fit-column-6 hdr-cell hdr-column"><span class="chart-in">10.24</span><span class="chart-cm">26.0</span></td>
                                            <td class="fit-column-7 hdr-cell hdr-column"><span class="chart-in">10.43</span><span class="chart-cm">26.5</span></td>
                                            <td class="fit-column-8 hdr-cell hdr-column"><span class="chart-in">10.63</span><span class="chart-cm">27.0</span></td>
                                            <td class="fit-column-9 hdr-cell hdr-column"><span class="chart-in">10.83</span><span class="chart-cm">27.5</span></td>
                                            <td class="fit-column-10 hdr-cell hdr-column"><span class="chart-in">11.02</span><span class="chart-cm">28.0</span></td>
                                            <td class="fit-column-11 hdr-cell hdr-column"><span class="chart-in">11.22</span><span class="chart-cm">28.5</span></td>
                                            <td class="fit-column-12 hdr-cell hdr-column"><span class="chart-in">11.42</span><span class="chart-cm">29.0</span></td>
                                            <td class="fit-column-13 hdr-cell hdr-column"><span class="chart-in">11.61</span><span class="chart-cm">29.5</span></td>
                                            <td class="fit-column-14 hdr-cell hdr-column"><span class="chart-in">11.81</span><span class="chart-cm">30.0</span></td>
                                            <td class="fit-column-15 hdr-cell hdr-column"><span class="chart-in">12</span><span class="chart-cm">30.5</span></td>
                                            <td class="fit-column-16 hdr-cell hdr-column"><span class="chart-in">12.2</span><span class="chart-cm">31.0</span></td>
                                            <td class="fit-column-17 hdr-cell hdr-column"><span class="chart-in">12.4</span><span class="chart-cm">31.5</span></td>
                                            <td class="fit-column-18 hdr-cell hdr-column"><span class="chart-in">12.6</span><span class="chart-cm">32.0</span></td>
                                            <td class="fit-column-19 hdr-cell hdr-column"><span class="chart-in">12.8</span><span class="chart-cm">32.5</span></td>
                                            <td class="fit-column-20 hdr-cell hdr-column"><span class="chart-in">13</span><span class="chart-cm">33.0</span></td>
                                        </tr>
                                        <tr>
                                            <td class="fit-column-1 hdr-cell hdr-fixed">US</td>
                                            <td class="fit-column-2 data-cell">6</td>
                                            <td class="fit-column-3 data-cell">6.5</td>
                                            <td class="fit-column-4 data-cell">7</td>
                                            <td class="fit-column-5 data-cell">7.5</td>
                                            <td class="fit-column-6 data-cell">8</td>
                                            <td class="fit-column-7 data-cell">8.5</td>
                                            <td class="fit-column-8 data-cell">9</td>
                                            <td class="fit-column-9 data-cell">9.5</td>
                                            <td class="fit-column-10 data-cell">10</td>
                                            <td class="fit-column-11 data-cell">10.5</td>
                                            <td class="fit-column-12 data-cell">11</td>
                                            <td class="fit-column-13 data-cell">11.5</td>
                                            <td class="fit-column-14 data-cell">12</td>
                                            <td class="fit-column-15 data-cell">12.5</td>
                                            <td class="fit-column-16 data-cell">13</td>
                                            <td class="fit-column-17 data-cell">13.5</td>
                                            <td class="fit-column-18 data-cell">14</td>
                                            <td class="fit-column-19 data-cell">14.5</td>
                                            <td class="fit-column-20 data-cell">15</td>
                                        </tr>
                                        <tr>
                                            <td class="fit-column-1 hdr-cell hdr-fixed">UK</td>
                                            <td class="fit-column-2 data-cell">5</td>
                                            <td class="fit-column-3 data-cell">5.5</td>
                                            <td class="fit-column-4 data-cell">6</td>
                                            <td class="fit-column-5 data-cell">6.5</td>
                                            <td class="fit-column-6 data-cell">7</td>
                                            <td class="fit-column-7 data-cell">7.5</td>
                                            <td class="fit-column-8 data-cell">8</td>
                                            <td class="fit-column-9 data-cell">8.5</td>
                                            <td class="fit-column-10 data-cell">9</td>
                                            <td class="fit-column-11 data-cell">9.5</td>
                                            <td class="fit-column-12 data-cell">10</td>
                                            <td class="fit-column-13 data-cell">10.5</td>
                                            <td class="fit-column-14 data-cell">11</td>
                                            <td class="fit-column-15 data-cell">11.5</td>
                                            <td class="fit-column-16 data-cell">12</td>
                                            <td class="fit-column-17 data-cell">12.5</td>
                                            <td class="fit-column-18 data-cell">13</td>
                                            <td class="fit-column-19 data-cell">13.5</td>
                                            <td class="fit-column-20 data-cell">14</td>
                                        </tr>
                                        <tr>
                                            <td class="fit-column-1 hdr-cell hdr-fixed">EUR</td>
                                            <td class="fit-column-2 data-cell">38</td>
                                            <td class="fit-column-3 data-cell">38.5</td>
                                            <td class="fit-column-4 data-cell">39</td>
                                            <td class="fit-column-5 data-cell">40</td>
                                            <td class="fit-column-6 data-cell">40.5</td>
                                            <td class="fit-column-7 data-cell">41</td>
                                            <td class="fit-column-8 data-cell">42</td>
                                            <td class="fit-column-9 data-cell">42.5</td>
                                            <td class="fit-column-10 data-cell">43</td>
                                            <td class="fit-column-11 data-cell">44</td>
                                            <td class="fit-column-12 data-cell">44.5</td>
                                            <td class="fit-column-13 data-cell">45</td>
                                            <td class="fit-column-14 data-cell">46</td>
                                            <td class="fit-column-15 data-cell">46.5</td>
                                            <td class="fit-column-16 data-cell">47</td>
                                            <td class="fit-column-17 data-cell">48</td>
                                            <td class="fit-column-18 data-cell">48.5</td>
                                            <td class="fit-column-19 data-cell">49</td>
                                            <td class="fit-column-20 data-cell">50</td>
                                        </tr>
                                        <tr>
                                            <td class="fit-column-1 hdr-cell hdr-fixed">JP</td>
                                            <td class="fit-column-2 data-cell">24</td>
                                            <td class="fit-column-3 data-cell">24.5</td>
                                            <td class="fit-column-4 data-cell">25</td>
                                            <td class="fit-column-5 data-cell">25.5</td>
                                            <td class="fit-column-6 data-cell">26</td>
                                            <td class="fit-column-7 data-cell">26.5</td>
                                            <td class="fit-column-8 data-cell">27</td>
                                            <td class="fit-column-9 data-cell">27.5</td>
                                            <td class="fit-column-10 data-cell">28</td>
                                            <td class="fit-column-11 data-cell">28.5</td>
                                            <td class="fit-column-12 data-cell">29</td>
                                            <td class="fit-column-13 data-cell">29.5</td>
                                            <td class="fit-column-14 data-cell">30</td>
                                            <td class="fit-column-15 data-cell">30.5</td>
                                            <td class="fit-column-16 data-cell">31</td>
                                            <td class="fit-column-17 data-cell">31.5</td>
                                            <td class="fit-column-18 data-cell">32</td>
                                            <td class="fit-column-19 data-cell">32.5</td>
                                            <td class="fit-column-20 data-cell">33</td>
                                        </tr>
                                        <tr>
                                            <td class="fit-column-1 hdr-cell hdr-fixed">KR</td>
                                            <td class="fit-column-2 data-cell">240</td>
                                            <td class="fit-column-3 data-cell">245</td>
                                            <td class="fit-column-4 data-cell">250</td>
                                            <td class="fit-column-5 data-cell">255</td>
                                            <td class="fit-column-6 data-cell">260</td>
                                            <td class="fit-column-7 data-cell">265</td>
                                            <td class="fit-column-8 data-cell">270</td>
                                            <td class="fit-column-9 data-cell">275</td>
                                            <td class="fit-column-10 data-cell">280</td>
                                            <td class="fit-column-11 data-cell">285</td>
                                            <td class="fit-column-12 data-cell">290</td>
                                            <td class="fit-column-13 data-cell">295</td>
                                            <td class="fit-column-14 data-cell">300</td>
                                            <td class="fit-column-15 data-cell">305</td>
                                            <td class="fit-column-16 data-cell">310</td>
                                            <td class="fit-column-17 data-cell">315</td>
                                            <td class="fit-column-18 data-cell">320</td>
                                            <td class="fit-column-19 data-cell">325</td>
                                            <td class="fit-column-20 data-cell">330</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="footnote">* Scroll horizontally to see more.</div>
                            <br> <br>
                            <span class="size-label">Width Conversion Chart</span>
                            <br> <br>
                            <div class="size-table-flex size-pants">
                                <div class="size-col">
                                    <div class="size-col-item size-hdr-border">Common Sizing</div>
                                    <div class="size-col-item border-right"><span>X Narrow (XN)</span></div>
                                    <div class="size-col-item border-right"><span>Narrow (N)</span></div>
                                    <div class="size-col-item border-right"><span>Medium (M)</span></div>
                                    <div class="size-col-item border-right"><span>Wide (W)</span></div>
                                    <div class="size-col-item border-right"><span>X Wide (XW)</span></div>
                                </div>
                                <div class="size-col">
                                    <div class="size-col-item size-hdr-border">Alpha Sizing</div>
                                    <div class="size-col-item"><span>3A, 2A</span></div>
                                    <div class="size-col-item"><span>A, B, C*</span></div>
                                    <div class="size-col-item"><span>C*, D, E</span></div>
                                    <div class="size-col-item"><span>E, 2E</span></div>
                                    <div class="size-col-item"><span>3E</span></div>
                                </div>
                            </div>
                            <div class="footnote">*A narrow C will generally take a Narrow, while a wider C will likely take a Medium.</div>
                            <br>
                            <h3>Measure Yourself</h3>
                            <hr class="display-desktop-only">
                            <div class="flex-lg">
                                <img alt="" class="image-right" src="https://www.footjoy.com/on/demandware.static/-/Library-Sites-FootJoySharedLibrary/default/dw8182c062/images/Guides/shoes-measure-yourself.jpg">
                                <div class="content-left">
                                    <p>Follow these three easy steps to determine your correct size.</p>

                                    <ol>
                                        <li>Place a piece of paper on the floor, lined up to a wall.  Place your foot on the paper so your heel is lightly touching the wall.</li>
                                        <li>Use a pen or pencil to mark the tip of your longest toe on the paper.  Using a ruler, measure the length of the paper up to the mark.</li>
                                        <li>Repeat these steps for the other foot and use our size conversion chart to compare your measurements to your correct size.</li>
                                    </ol>
                                </div>
                            </div>
                            <div class="relative">
                                <div class="size-description size-box full-mobile">
                                    <h4>Fit Tips</h4>
                                    <ul>
                                        <li>Your feet may swell over the course of the day, so you should always get measured towards the end of the day.</li>
                                        <li>Choose the larger size if feet are between sizes or if one foot is bigger than the other.</li>
                                        <li>Re-measure your feet each year. Your size and width can change over time and the correct fit is important for comfort and performance.</li>
                                    </ul>
                                </div>
                            </div>
                            <h3>Free Returns</h3>
                            <div class="size-description">
                                <p>Not sure about your size? Order a half size up and a half size down, and return the one that doesn't fit. It's worry-free.</p>
                                <ul>
                                    <li>Free returns shipping &amp; processing</li>
                                    <li>Returns accepted for unworn, unaltered merchandise for any reason (within 30 days of delivery date)</li>
                                    <li>Learn more about our <a href="https://www.footjoy.com/returns.html">return policy</a></li>
                                </ul>
                            </div>
                            <hr>
                            <div class="size-description">
                                <h4>Frequently Asked Questions</h4>
                                <p>Our product experts have provided answers to our most commonly asked sizing and fit questions.</p> <a href="https://www.footjoy.com/golf-shoe-fitting-guide.html" class="size-lnk">View FAQ</a>
                                <p>&nbsp;</p>
                                <h4>Need Help?</h4>
                                <p>Still have questions? Our FootJoy experts can help you find your perfect size. Call <a href="tel:8002248501">(800) 224-8501</a> (M-Th 8:00 am to 5:00 pm EST, F 8:30 am to 5:00 pm EST)</p>
                                <p><a href="https://www.footjoy.com/contact" class="size-lnk">Contact Us</a></p>
                                <p>&nbsp;</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                cmButton: null,
                inchesButton: null,
                cmElements: [],
                inchElements: [],

                useRealContent: true,
                sizeGuideHtml: '',
            };
        },

        computed: {
            locale() {
                return this.customizerStore.options?.locale;
            },

            shortLocale() {
                const locale = this.locale.replace('_', '-').toLowerCase();

                return locale.split('-')[0];
            },

            baseUrl() {
                return this.customizerStore.baseSiteUrl;
            },

            sizeGuideUrl() {
                const department = this.customizerStore.productDepartment === 'F' ? 'women' : 'men';

                const contentId = `fitting-${department}-shoes`;

                return `${this.baseUrl}Page-Include?cid=${contentId}`;
            },
        },

        watch: {
            showModal() {
                setTimeout(() => {
                    this.cmButton = document.querySelector('.btn-cm');
                    this.inchesButton = document.querySelector('.btn-in');

                    if (this.showModal) {
                        // Set inches button to active by default
                        this.inchesButton.classList.add('active-btn');

                        this.inchesButton.addEventListener('click', this.showInches);
                        this.cmButton.addEventListener('click', this.showCentimeters);
                    } else {
                        this.inchesButton.removeEventListener('click', this.showInches);
                        this.cmButton.removeEventListener('click', this.showCentimeters);
                    }
                }, 100);
            },
        },

        mounted() {
            fetch(this.sizeGuideUrl).then((response) => response.text()).then((html) => {
                this.sizeGuideHtml = html;
            });
        },

        methods: {
            showInches() {
                const cmElements = document.getElementsByClassName('chart-cm');
                const inchElements = document.getElementsByClassName('chart-in');

                this.inchesButton.classList.add('active-btn');
                this.cmButton.classList.remove('active-btn');

                cmElements.forEach((element) => {
                    element.style.display = 'none';
                });

                inchElements.forEach((element) => {
                    element.style.display = 'block';
                });
            },

            showCentimeters() {
                const cmElements = document.getElementsByClassName('chart-cm');
                const inchElements = document.getElementsByClassName('chart-in');

                this.inchesButton.classList.remove('active-btn');
                this.cmButton.classList.add('active-btn');

                cmElements.forEach((element) => {
                    element.style.display = 'block';
                });

                inchElements.forEach((element) => {
                    element.style.display = 'none';
                });
            },

            emitClose() {
                this.$emit('modalClose');
            },
        },
    };
</script>

<style lang="scss">
    #cz3 {
        .cz3-size-guide-modal {
            @apply pr-4 md:pr-9;

            ul,
            ol {
                @apply my-4 px-6 leading-6;
            }

            ul {
                li {
                    @apply list-disc;
                }
            }

            ol {
                li {
                    @apply list-decimal;
                }
            }

            .btn-toggle {
                @apply border border-black flex;
            }

            .btn-cm,
            .btn-in {
                @apply cursor-pointer p-2.5 min-w-[44px] text-center;
            }

            .active-btn {
                @apply bg-black text-white;
            }

            /* Hide cm measurements by default */
            .chart-cm {
                @apply cz-hidden;
            }

            /* Size table */
            .size-tlt {
                @apply mb-3 md:mb-4 text-4xl font-bold tracking-wide normal-case;
            }

            .size-find-tlt,
            h3 {
                @apply text-2xl font-semibold;
            }

            h3 {
                @apply mt-12;
            }

            hr {
                @apply my-6 border-b border-gray-light;
            }

            .size-label {
                @apply mb-6 text-lg;
            }

            .size-conversion {
                @apply flex items-center justify-between;
            }

            .size-scroll {
                @apply relative overflow-x-auto;
            }

            .size-shoes {
                @apply mb-7 border-spacing-0;

                td {
                    @apply text-center align-middle;
                }
            }

            .hdr-fixed-corner {
                @apply border-b border-r border-black;
            }

            .hdr-fixed {
                @apply sticky left-0 border-r border-black bg-white;
            }

            .hdr-column {
                @apply border-b border-black;
            }

            .hdr-column,
            .hdr-cell {
                @apply font-bold min-w-[67px];
            }

            .hdr-cell {
                padding: 2% 15px;
            }

            tr td:nth-child(even):not(.hdr-column):not(.fit-col-hover),
            .size-column:nth-child(even):not(.fit-col-hover),
            .size-col-item:nth-child(even):not(.fit-col-hover) {
                @apply bg-gray-light;
            }

            .footnote {
                @apply mt-6 text-sm;
            }

            /* Width table */
            .size-pants {
                @apply flex text-center border-collapse;

                .size-col {
                    @apply flex-1;

                    .size-col-item {
                        @apply p-4;
                    }

                    .border-right {
                        @apply border-r border-black;
                    }

                    .flex-lg {
                        @apply flex;
                    }
                }
            }

            .size-hdr-border {
                @apply border-b-2 border-black font-bold;
            }

            /* Measure yourself section */
            .size-chart h3 {
                @apply mt-12 mb-6;
            }
            .flex-lg {
                @apply lg:flex lg:flex-row;

                .content-left {
                    @apply px-4 md:px-16 py-3;

                    p {
                        @apply my-4 text-xl;
                    }
                }

                .image-right {
                    @apply w-full md:order-1;
                }
            }

            /* Fit tips */
            .size-box {
                @apply mt-12 px-4 py-12 sm:p-12 bg-gray-lighter;

                h4 {
                    @apply my-5 font-bold;
                }
            }

            .size-description {
                h4 {
                    @apply my-4 font-bold;
                }

                p {
                    @apply my-4 text-xl;
                }

                a {
                    @apply underline;
                }
            }
        }
    }
</style>
